import {
  MdEmail,
  MdLocationOn,
  MdOutlineAccessTime,
  MdPhone,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { companyInfo, regions } from "./RunzeweContent";

export default function ContactUsContent() {
  return (
    <>
      <section className="page-hero contact-page-hero">
        <div className="page-hero-overlay" />
        <div className="container page-hero-content" data-aos="fade-up">
          <p className="section-kicker">Contact Us</p>
          <h1>Ready to Secure Your Site?</h1>
          <p>
            Reach Runzewe Security for guarding, patrol, event protection,
            electronic security, and risk assessment support.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="contact-grid">
            <a className="contact-card" href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} data-aos="fade-up">
              <MdPhone />
              <span>Phone</span>
              <strong>{companyInfo.phone}</strong>
            </a>

            <a className="contact-card" href="https://wa.me/255715771677" target="_blank" rel="noreferrer" data-aos="fade-up" data-aos-delay="70">
              <FaWhatsapp />
              <span>WhatsApp</span>
              <strong>{companyInfo.whatsapp}</strong>
            </a>

            <a className="contact-card" href={`mailto:${companyInfo.email}`} data-aos="fade-up" data-aos-delay="140">
              <MdEmail />
              <span>Email</span>
              <strong>{companyInfo.email}</strong>
            </a>

            <div className="contact-card" data-aos="fade-up" data-aos-delay="210">
              <MdOutlineAccessTime />
              <span>Working Hours</span>
              <strong>24/7 Monitoring</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section section-soft">
        <div className="container">
          <div className="split-grid">
            <div data-aos="fade-right">
              <p className="section-kicker">Office & Coverage</p>
              <h2>Headquartered in Geita with nationwide reach.</h2>
              <p>
                {companyInfo.address}. The company also maintains branch
                presence including {companyInfo.darOffice}, with approved
                operating coverage across multiple regions.
              </p>

              <div className="address-box">
                <MdLocationOn />
                <div>
                  <strong>{companyInfo.mailingAddress}</strong>
                  <span>{companyInfo.address}</span>
                </div>
              </div>
            </div>

            <div className="region-panel" data-aos="fade-left">
              <h3>Service Regions</h3>
              <div className="region-list">
                {regions.map((region) => (
                  <span key={region}>{region}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
